<template>
  <Scheduler class="py-25 sm:px-50 max-w-xl" @cancel="$emit('close')">
  </Scheduler>
</template>

<script>
import Scheduler from './Scheduler'

export default {
  components: { Scheduler },
}
</script>

<style></style>
